<template>
  <div class="sky-success-step checkout-feedback-screen flow-step">
    <h1>Vínculo efetuado com sucesso!</h1>
    <img src="@/assets/sky-confirmation.png" alt />
    <p>Oba! Agora você e seu pequeno podem aproveitar o PlayKids em todas as plataformas disponíveis:</p>

    <div class="sky-success-step__apps">
      <a href="https://play.google.com/store/apps/details?id=com.movile.playkids" target="_blank">
        <img src="@/assets/google-play.png" />
      </a>
      <a href="https://apps.apple.com/br/app/playkids-learn-through-play/id613398383" target="_blank">
        <img src="@/assets/app-store.png" />
      </a>
    </div>

    <p>Acesse também nossa versão web <a @click.prevent="finish">clicando aqui.</a></p>
  </div>
</template>

<script>
import store from 'store'

export default {
  name: 'sky-success-step',
  methods: {
    finish() {
      store.set('onboarding_finished', false)
      this.$router.push({ name: 'browse' })
    }
  }
}
</script>

<style lang="scss" scoped>
.sky-success-step {
  > img {
    width: 100%;
    margin-bottom: 18px;
  }

  > .btn {
    margin-bottom: 24px;
  }

  &__apps {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    margin: 12px 0;

    & > a {
      margin: 4px 8px;

      & > img {
        width: 150px;
      }
    }
  }
}
</style>
